import React from "react";
import { Route, Switch } from "react-router-dom";
//import { AuthUserRoute } from './AuthUserRoute';
import { SuperUserAuthRoute } from './SuperUserAuthRoute';
import { AuthUserRoute } from './AuthUserRoute';
import NotFound from "../containers/NotFound";
import LandingPage from "../containers/LandingPage"
import MyProfilePage from "../containers/MyProfilePage"
import EventsPage from "../containers/EventsPage"
import EventPage from "../containers/EventPage"
import EventForm from "../containers/EventForm"
import MyEventsPage from "../containers/MyEventsPage"
import CaptureEventPage from "../containers/CaptureEventPage"
import PrivacyPage from "../containers/PrivacyPage"
import CompleteSignIn from '../containers/CompleteSignIn'
import UnAuthorisedPage from '../components/UnAuthorisedPage'
import TestComponent from "../containers/TestComponent"


export class Routes extends React.Component {
  render() {
    //console.log("Routes")
    //console.log(this.props)
    return (
      <Switch>
        <Route
          exact path="/"
          component={LandingPage}
        />

        <Route
          exact path="/unauthorised"
          component={UnAuthorisedPage}
        />

        <Route
          exact path="/privacy"
          component={PrivacyPage}
        />

        <Route
          exact path="/events"
          component={EventsPage}
        />

        <SuperUserAuthRoute
          exact path="/events/new"
          component={EventForm}
          {...this.props}
        />

        <SuperUserAuthRoute
          exact path="/events/:id/edit"
          component={EventForm}
          {...this.props}
        />

        <Route
          exact path="/events/:id"
          component={EventPage}
        />

        <SuperUserAuthRoute
          exact path="/myevents"
          component={MyEventsPage}
          {...this.props}
        />


        <AuthUserRoute
          exact path="/captureevent"
          component={CaptureEventPage}
        />

        <Route
          path="/completesignin"
          component={CompleteSignIn}
        />

        <AuthUserRoute
          path="/myprofile"
          component={MyProfilePage}
        />


        <Route render={(props) => (<NotFound /> )} />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Routes.js